import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton, Link as MuiLink, List, ListItem, ListItemText, Popover, Typography } from '@mui/material';
import { useState, type JSX, type MouseEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNotes } from '../api/hooks/useNotes';
import { PriorityChip } from '../components/PriorityChip';
import { translateNoteTargetUrl } from '../routing/noteTargetUrl';

/** docs/design/MUI-Komponenten.md "Shell": Glocke + Badge -> Popover mit Meldungsliste. */
export function NotificationsBell(): JSX.Element {
  const { data } = useNotes('recent');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openCount = data?.filter((note) => note.status === 'open').length ?? 0;

  return (
    <>
      <IconButton
        data-testid="notifications-bell"
        color="inherit"
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
        aria-label="Meldungen"
      >
        <Badge badgeContent={openCount} color="error" invisible={openCount === 0}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <List sx={{ minWidth: 320, maxWidth: 420 }} data-testid="notifications-list">
          {(data ?? []).slice(0, 8).map((note) => (
            <ListItem
              key={note.id}
              component={RouterLink}
              to={translateNoteTargetUrl(note.targetUrl)}
              onClick={() => setAnchorEl(null)}
            >
              <ListItemText primary={<PriorityChip priority={note.priority} />} secondary={note.ursache} />
            </ListItem>
          ))}
          {(data ?? []).length === 0 && (
            <ListItem>
              <Typography variant="body2" color="text.secondary">
                Kein Handlungsbedarf
              </Typography>
            </ListItem>
          )}
          <ListItem>
            <MuiLink component={RouterLink} to="/" onClick={() => setAnchorEl(null)}>
              Alle Meldungen im Dashboard
            </MuiLink>
          </ListItem>
        </List>
      </Popover>
    </>
  );
}
